export interface PlanLimits {
  maxForms: number;
  maxResponses: number;
  hasEmailNotifications: boolean;
  hasAdvancedAnalytics: boolean;
}

export const PLAN_LIMITS: Record<string, PlanLimits> = {
  trial: {
    maxForms: 15, // Same as professional during trial
    maxResponses: -1, // Unlimited during trial
    hasEmailNotifications: true,
    hasAdvancedAnalytics: true,
  },
  starter: {
    maxForms: 1,
    maxResponses: 100,
    hasEmailNotifications: false,
    hasAdvancedAnalytics: false,
  },
  professional: {
    maxForms: 15,
    maxResponses: -1, // Unlimited
    hasEmailNotifications: true,
    hasAdvancedAnalytics: true,
  },
  enterprise: {
    maxForms: 100,
    maxResponses: -1, // Unlimited
    hasEmailNotifications: true,
    hasAdvancedAnalytics: true,
  },
};

export const DEFAULT_LIMITS: PlanLimits = PLAN_LIMITS.trial;

export function getPlanLimits(
  subscription: any | null,
  isOnTrial: boolean,
  isTrialExpired: boolean
): PlanLimits {
  // If user is on trial, give them professional limits
  if (isOnTrial && !isTrialExpired) {
    return PLAN_LIMITS.trial;
  }

  // If user has an active subscription, use their plan limits
  if (subscription?.status === 'active' && subscription.plan) {
    return PLAN_LIMITS[subscription.plan] || DEFAULT_LIMITS;
  }

  // If trial is expired and no subscription, use starter limits
  if (isTrialExpired) {
    return PLAN_LIMITS.starter;
  }

  // Default to trial limits for new users
  return DEFAULT_LIMITS;
}

export function getNextPlan(currentPlan: string): string | null {
  const planOrder = ['starter', 'professional', 'enterprise'];
  const currentIndex = planOrder.indexOf(currentPlan);
  
  if (currentIndex === -1 || currentIndex === planOrder.length - 1) {
    return null; // Already on highest plan or unknown plan
  }
  
  return planOrder[currentIndex + 1];
}

export function getPlanDisplayName(plan: string): string {
  const displayNames: Record<string, string> = {
    starter: 'Starter',
    professional: 'Professional',
    enterprise: 'Enterprise',
    trial: 'Trial',
  };
  
  return displayNames[plan] || 'Unknown';
} 